export default __webpack_public_path__ + "assets/img/login-user.svg";